import BinStoreFAQs from './BinStoreFAQs'
import { useRouter } from 'next/router'
import Image from 'next/image'
import { BinStoreLocation } from './BinStoreLocation'
import BinStoreForm from '../../lib/Klaviyo/EmailSignup/BinStoreForm'
import { MainObject, TransformedLocation } from '@components/BinStore/types'
import { FC } from 'react'

const BinStore: FC<MainObject> = (props) => {
  const { data } = props

  const {
    bin_product,
    bin_product_images,
    policy,
    policies,
    FAQ,
    faqs,
    locations: locationsData,
  } = data
  const router = useRouter()

  function formatPrice(price: number) {
    if (Number.isInteger(price)) {
      return price.toString()
    } else {
      return price.toFixed(2)
    }
  }

  const locations: TransformedLocation[] = locationsData.map(
    ({
      id,
      nickName,
      address,
      hours,
      url,
      mondayPrice,
      tuesdayPrice,
      wednesdayPrice,
      thursdayPrice,
      fridayPrice,
    }) => ({
      id: id,
      name: nickName,
      address: address,
      hours,
      locationUrl: url,
      binDealsData: [
        {
          color: 'bidfta-yellow-legacy',
          price: `$${formatPrice(mondayPrice)}`,
          day: 'Monday',
          dayAbbrev: 'Mon',
        },
        {
          color: 'bidfta-blue-light',
          price: `$${formatPrice(tuesdayPrice)}`,
          day: 'Tuesday',
          dayAbbrev: 'Tues',
        },
        {
          color: 'bidfta-lightblue',
          price: `$${formatPrice(wednesdayPrice)}`,
          day: 'Wednesday',
          dayAbbrev: 'Weds',
        },
        {
          color: 'bidfta-blue-backdrop-light',
          price: `$${formatPrice(thursdayPrice)}`,
          day: 'Thursday',
          dayAbbrev: 'Thurs',
        },
        {
          color: 'bidfta-blue-backdrop-dark',
          price: `$${formatPrice(fridayPrice)}`,
          day: 'Friday',
          dayAbbrev: 'Fri',
        },
      ],
    })
  )

  return (
    <div className="w-full bg-white">
      <div className="bg-[#132C52] w-full">
        <div className="max-w-[1440px] px-4 mx-auto text-center">
          <div className="px-6 py-14 ">
            <h1 className="text-[#F5F5F5] text-[40px] md:text-[64px] leading-[40px] md:leading-[64px] font-extrabold py-8 px-2 md:px-0">
              {bin_product.title}
            </h1>
            <p className="text-[#FECE62] text-[16px] md:text-[26px] font-bold max-w-3xl pb-2 mx-auto">
              {bin_product.description}
            </p>
            <button
              className="border border-[#3092A6] rounded-[3px] px-16 py-2 bg-[#3092A6] text-white text-[18px] md:text-[20px] font-extrabold mt-4 mb-[2px] "
              onClick={() => router.push('/bin-store#locations')}
            >
              FIND BIN STORES
            </button>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="max-w-[1440px] px-[48px] mx-auto text-center pt-16">
          <h2 className="text-[36px] md:text-[48px]  font-extrabold underline decoration-1 underline-offset-[20px] pt-4 text-[#132C52]">
            {FAQ.title}
          </h2>
          <p className=" text-[14px] md:text-[20px] max-w-3xl pt-8 mx-auto  text-[#132C52]">
            {FAQ.description}
          </p>
        </div>
        <div className="lg:max-w-full xl:max-w-[1076px] mx-auto rounded-[10px] mb-28 md:mb-14 space-y-10 pt-12">
          <div className="grid grid-cols-1  md:grid-cols-3 gap-10 justify-center items-center justify-items-center md:justify-items-stretch">
            {bin_product_images.map((item, index: number) => (
              <div className="flex  rounded-xl" key={index}>
                <div className="relative border-full bg-gray-50 overflow-hidden flex  w-[300px] h-[300px] rounded-md">
                  <Image
                    unoptimized
                    src={item.url}
                    alt={`Bin Store Product ${index}`}
                    width={300}
                    height={300}
                    className="object-cover object-center w-full h-full"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-white flex justify-center w-full">
        <div
          className="max-w-[1440px] mobile-padding sm:px-[48px] mx-auto text-center pt-0 md:pt-8"
          id="locations"
        >
          <h2 className="text-[36px] md:text-[48px]  font-extrabold underline decoration-1 underline-offset-[20px] md:pt-8 text-[#132C52]">
            Locations
          </h2>
          <div className="md:max-w-full lg:max-w-[1076px] mx-auto mb-32 mt-8">
            {locations.map((location, index: number) => (
              <div
                key={index}
                className="bg-[#F5F5F5] rounded-[10px] p-4 md:p-8 lg:p-10 xl:px-12 mb-8"
              >
                <BinStoreLocation key={index} {...location} />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-[#F5F5F5]" id="faq">
        <div className="max-w-[1440px] px-4 mx-auto text-center py-16">
          <h2 className="text-[36px] md:text-[48px]  font-extrabold text-[#132C52]">
            FAQs
          </h2>
          <div className="max-w-[950px] mx-auto py-10 px-8 md:px-10">
            <BinStoreFAQs data={faqs} />
          </div>
        </div>
      </div>

      <div className="bg-[#3C7CB7]">
        <div className="max-w-[1440px] px-4 mx-auto text-center py-16">
          <h2 className="text-[36px] md:text-[48px] font-extrabold underline decoration-1 underline-offset-[20px] text-[#F5F5F5]">
            {policy.title}
          </h2>
          <div className="pt-8 max-w-[255px] md:max-w-[783px] mx-auto">
            <p className="text-[#F5F5F5] text-[18px] md:text-[24px] font-light pb-2">
              {policy.description}{' '}
            </p>
            {policies.map((policy) => (
              <p
                key={`policy-${policy.id}`}
                className="text-[#F5F5F5] text-[18px] md:text-[24px] font-light mb-2"
              >
                {policy.policy}
              </p>
            ))}
          </div>
        </div>
      </div>

      <BinStoreForm />
    </div>
  )
}

export default BinStore
